function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.1 0.1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M552.334,348.848h3.376a.631.631,0,0,0,0-1.262h-3.376a.631.631,0,1,0,0,1.262Zm0,0",
  transform: "translate(-524.536 -343.156)",
  fill: "#0078d7",
  stroke: "#00abff",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M397.76,364.864V318.8a2.771,2.771,0,0,0-2.734-2.8H360.734A2.771,2.771,0,0,0,358,318.8v46.063a2.818,2.818,0,0,0,2.734,2.888h34.293a2.817,2.817,0,0,0,2.734-2.888Zm-19.288-31.485H396.5v16.1H378.473ZM396.5,318.8v13.316H378.473V317.262h16.554A1.507,1.507,0,0,1,396.5,318.8Zm-37.236,46.063V318.8a1.507,1.507,0,0,1,1.471-1.538H377.21V366.49H360.734a1.556,1.556,0,0,1-1.471-1.626Zm35.765,1.626H378.473V350.743H396.5v14.12a1.556,1.556,0,0,1-1.471,1.626Zm0,0",
  transform: "translate(-358 -316)",
  fill: "#0078d7",
  stroke: "#001383",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.835 20.678)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M471.541,494.523a.632.632,0,0,0-.631.631v4.068a.631.631,0,1,0,1.262,0v-4.068a.631.631,0,0,0-.631-.631Zm0,0",
  transform: "translate(-470.91 -490.164)",
  fill: "#0078d7",
  stroke: "#00abff",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M555.71,463.441h-3.376a.631.631,0,1,0,0,1.262h3.376a.631.631,0,1,0,0-1.262Zm0,0",
  transform: "translate(-540.372 -463.441)",
  fill: "#0078d7",
  stroke: "#00abff",
  strokeWidth: 0.2
})), /*#__PURE__*/React.createElement("path", {
  d: "M555.71,586.48h-3.376a.631.631,0,1,0,0,1.262h3.376a.631.631,0,1,0,0-1.262Zm0,0",
  transform: "translate(-524.536 -548.546)",
  fill: "#0078d7",
  stroke: "#00abff",
  strokeWidth: 0.2
}));

function SvgLocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.96,
    height: 51.952,
    viewBox: "0 0 39.96 51.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.5ec5a4a6.svg";
export { ForwardRef as ReactComponent };